import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { LogOut, User, Bell, Moon, ChevronDown } from 'lucide-react';
import './Header.css';

function Header() {
  const { user, logout } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleLogout = async () => {
    await logout();
    window.location.href = '/login';
  };

  return (
    <header className="header">
      <div className="header-left">
      </div>

      <div className="header-right">
        <button className="header-btn" title="Уведомления">
          <Bell size={20} />
          <span className="notification-badge">3</span>
        </button>

        <button className="header-btn" title="Тема">
          <Moon size={20} />
        </button>

        <div className="user-menu-container">
          <button 
            className="user-menu-toggle"
            onClick={() => setShowUserMenu(!showUserMenu)}
          >
            <div className="user-avatar">
              {user?.username?.[0]?.toUpperCase() || 'A'}
            </div>
            <span className="user-name">{user?.username || 'admin'}</span>
            <ChevronDown size={16} />
          </button>

          {showUserMenu && (
            <>
              <div 
                className="user-menu-backdrop"
                onClick={() => setShowUserMenu(false)}
              />
              <div className="user-menu">
                <div className="user-menu-header">
                  <div className="user-avatar lg">
                    {user?.username?.[0]?.toUpperCase() || 'A'}
                  </div>
                  <div className="user-info">
                    <span className="user-name">{user?.username || 'admin'}</span>
                    <span className="user-role">Администратор</span>
                  </div>
                </div>
                <div className="user-menu-divider" />
                <button className="user-menu-item">
                  <User size={18} />
                  <span>Профиль</span>
                </button>
                <button className="user-menu-item logout" onClick={handleLogout}>
                  <LogOut size={18} />
                  <span>Выйти</span>
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
